module.exports = __webpack_public_path__ + "img/公司图片.61a5df2b.png";